import { stringify } from 'query-string';

export const updateLinkParams = (link: string, searchParams: {[key: string]: string | boolean | number} ) =>{
	const hash = link.match(/#(.*)/)?.[0] || '';
	const linkNoHash = link.replace(hash, '');
	const paramsString = stringify(searchParams);
	const linkWithParams = paramsString.length
		? `${linkNoHash}${ linkNoHash?.includes('?') ? '&' : '?' }${paramsString}`
		: linkNoHash;

	return linkWithParams + hash;
};
